import { useFetch } from '@gluedigital/ruse-fetch-extras'
import { ADMIN_URL } from 'src/constants/global'
import type { CompanyDataResponse } from 'src/types/global'

export const useCompanyData = (id: string): CompanyDataResponse =>
  useFetch<CompanyDataResponse>(ADMIN_URL + '/companies/' + id)
